export default __webpack_public_path__ + "static/media/subscriptions.2a0bb454.svg";